module.exports = __webpack_public_path__ + "static/media/up.e5685e0f.svg";